const styles = {
  separator: {
    textAlign: "center",
    lineHeight: 0,
    borderBottom: "1px solid #ccc",
    margin: "25px auto 10px",
    width: "100%"
  },
  separatorInner: {
    backgroundColor: "#fff",
    fontStyle: "italic",
    fontFamily: "serif",
    padding: "0 6px",
    textTransform: "uppercase",
    fontSize: 16,
    color: "rgb(115, 115, 115)",
    fontWeight: "bold"
  }
};

export default ({ label, style }) => {
  return (
    <div style={Object.assign({}, styles.separator, style)}>
      <span style={styles.separatorInner}>{label}</span>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/partials/horizontal-separator.jsx